import { FormattedMessage } from 'react-intl'
import { Link } from '@tanstack/react-router'

import { Button } from '@gto/ui/button'
import { Typography } from '@gto/ui/typography'

import { ArrowRightSmallIcon } from '@/assets/icons'

type FreeBankrollHeroSectionProps = {
  isAuthorized: boolean
}

export const FreeBankrollHeroSection = ({ isAuthorized }: FreeBankrollHeroSectionProps) => {
  return (
    <section className="mx-auto flex w-full max-w-[820px] flex-col items-center py-[96px] text-center md:pb-[52px] md:pt-[40px] sm:px-2">
      <div className="flex w-full flex-col items-center gap-[18px] text-center align-middle">
        <Typography
          className="mx-auto max-w-[680px]"
          color="text.primary"
          component="h1"
          variant="h3"
        >
          <FormattedMessage
            id="freeBankroll.hero.title"
            values={{
              lineBreak: () => <br />,
              highlight: (chunks) => (
                <Typography
                  className="[font-size:inherit] [font-weight:inherit] [line-height:inherit]"
                  color="primary"
                  component="span"
                >
                  {chunks}
                </Typography>
              ),
            }}
          />
        </Typography>

        <Typography
          className="mx-auto text-center"
          component="h2"
          variant="button/large"
        >
          <FormattedMessage
            id="freeBankroll.hero.description"
            values={{ prize: '$500' }}
          />
        </Typography>
      </div>

      {!isAuthorized && (
        <Button
          as={Link}
          className="mt-[54px]"
          preload={false}
          size="large"
          to="/login"
          variant="contained"
          endIcon={
            <div className="flex size-12">
              <ArrowRightSmallIcon
                height={24}
                width={24}
              />
            </div>
          }
        >
          <FormattedMessage id="common.controls.createAccount" />
        </Button>
      )}
    </section>
  )
}
